import { apiClient } from '../api/apiClient';

export interface WalletBalance {
  balance_usd: number;
  credit_balance_usd?: number;
  credit_balance_expiry?: string;
  currency: string;
  holder_type: string;
  holder_id: string;
}

export interface WalletTransactionItem {
  id: string;
  type: string;
  amount_usd: number;
  balance_after_usd: number | null;
  reference_type: string;
  reference_id: string | null;
  created_at: string;
}

export interface WalletTransactionsResponse {
  transactions: WalletTransactionItem[];
  total: number;
}

export const walletService = {
  getBalance(): Promise<WalletBalance> {
    return apiClient.get<WalletBalance>('/api/v1/wallet/balance').then((r) => r.data);
  },

  getTransactions(
    skip = 0,
    limit = 50,
    fromDate?: string | null,
    toDate?: string | null
  ): Promise<WalletTransactionsResponse> {
    const params: Record<string, number | string> = { skip, limit };
    if (fromDate) params.from_date = fromDate;
    if (toDate) params.to_date = toDate;
    return apiClient
      .get<WalletTransactionsResponse>('/api/v1/wallet/transactions', { params })
      .then((r) => r.data);
  },

  createRechargeOrder(
    amount_usd: number,
    provider?: string,
    return_to = 'web'
  ): Promise<{
    order_id: string;
    payment_session_id?: string;
    checkout_url?: string;
    amount_usd: number;
    order_amount_inr: number;
    order_currency: string;
  }> {
    return apiClient
      .post('/api/v1/wallet/recharge/create', {
        amount_usd,
        provider,
        return_to,
      })
      .then((r) => r.data);
  },
};
